import { call, put } from 'redux-saga/effects';
import {
    requestGetTags,
    requestGetAssignableTags,
    requestCreateTag,
    requestUpdateTag,
    requestDeleteTag,
    requestRestoreTag,
    requestGetTagUsage,
    requestSetTagAssignments,
    requestGetInheritedTags,
    requestGetTagDetail,
    requestUpdateTagContext,
} from '../requests/tag';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetTags(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetTags, action.payload.params);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetAssignableTags(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetAssignableTags, action.payload.params);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleCreateTag(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestCreateTag, action.payload.tagData);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleUpdateTag(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestUpdateTag, action.payload.tagId, action.payload.tagData);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleDeleteTag(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestDeleteTag, action.payload.tagId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleRestoreTag(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestRestoreTag, action.payload.tagId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetTagUsage(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetTagUsage, action.payload.tagId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleSetTagAssignments(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestSetTagAssignments, action.payload.targetType, action.payload.targetId, action.payload.assignments);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetInheritedTags(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetInheritedTags, action.payload.params);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetTagDetail(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetTagDetail, action.payload.tagId);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleUpdateTagContext(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestUpdateTagContext, action.payload.tagId, action.payload.context);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}
